import { getAPIHost } from '@rsos/utils/metaTags';

const authenticateWithSSO = async (email, redirectURI) => {
  // Business rule: callers may pass plus-address emails and redirect URIs that
  // themselves contain query params, such as /irp-sso?query=tel%3A%2F%2F...
  // URLSearchParams keeps legacy /sso behavior while preserving those nested
  // values for the SSO-first iRP callback.
  const queryParams = new URLSearchParams({
    email,
    redirect_uri: redirectURI,
  });

  const resp = await fetch(
    `${getAPIHost()}/v1/scorpius/sso/authenticate?${queryParams.toString()}`,
    {
      method: 'GET',
      credentials: 'include',
    },
  );
  const data = await resp.json();
  return data?.authorization_url;
};

export default authenticateWithSSO;
